module.exports = __webpack_public_path__ + "img/download-fff.586c7f74.svg";